import BaseRepository from '@/baseRepository/BaseRepository';
const resource = `/api/v1/files`;

export default {
  getFilesByFolderType(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/pagedlist/byfoldertype`, {
      baseURL,
      headers,
      params,
    });
  },
  sendFileByFolderType(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/byfoldertype`, body, {
      baseURL,
      headers,
      params,
    });
  },
  sendFile(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
};
